module.exports = __webpack_public_path__ + "static/media/view5_bg3.15d8f60d.png";